import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client/react';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';

import { SnackbarProvider } from 'notistack';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import GlobalStyles from './components/GlobalStyles';

import { createApolloClient } from './utils/apiHelper';

import { renderRoutes, routes } from './routes';
import getStripe from './utils/getStripe';
import { AuthProvider } from './hooks/use-auth';
import { createTheme } from './theme';
import { Elements } from '@stripe/react-stripe-js';

import 'pace-progressbar';
import 'pace-progressbar/themes/blue/pace-theme-minimal.css';

export default function App() {
  const theme = createTheme({ theme: 'LIGHT' });

  const apolloClient = createApolloClient();

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <SnackbarProvider dense maxSnack={3}>
          <BrowserRouter>
            <AuthProvider>
              <Elements stripe={getStripe()}>
                <GlobalStyles />
                <ApolloProvider client={apolloClient}>
                  <DndProvider backend={HTML5Backend}>
                    {renderRoutes(routes)}
                  </DndProvider>
                </ApolloProvider>
              </Elements>
            </AuthProvider>
          </BrowserRouter>
        </SnackbarProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
